import PropTypes from "prop-types";
import ClearwaysDeviceSettingsForm from "./form";

import groupAPI from "services/api/groups";
import sitesAPI from "services/api/sites";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { wrapper } from "utils/wrapper";
import { processGroupData } from "utils/group";
import { getUserAccessLevel } from "utils/setup";
import { processDeviceData } from "utils/device";

function ClearwaysDeviceSettings({ uuid, selected_device, user_type, deviceLayout }) {

    groupAPI.loadToken(useAuth0());
    sitesAPI.loadToken(useAuth0());

    const sites = useQuery({
        queryKey: ['getAllSites'],
        queryFn: async () => {
            return await sitesAPI.getAllSites();
        }
    });

    const groups = useQuery({
        queryKey: ['getAllGroups'],
        queryFn: async () => {
            return await groupAPI.getAllGroups();
        }
    });

    const group = useQuery({
        queryKey: ['getGroupWithDeviceUUID', uuid],
        queryFn: async () => {
            return await groupAPI.getGroupWithDeviceUUID(uuid);
        }
    });

    if (groups.isLoading || group.isLoading || sites.isLoading) {
        return wrapper('Loading...', deviceLayout);
    }

    if (groups.error || group.error || sites.error) {
        if (sites.error) {
            var error = sites.error;
        }
        else if (groups.error) {
            var error = groups.error;
        }
        else if (group.error) {
            var error = group.error;
        }

        return wrapper("An error has occurred: " + error.message, deviceLayout);
    }

    if (!sites.data) {
        return wrapper('Loading...', deviceLayout);
    }

    var basic_groups_data = groups.data.map(function (group) {
        var ret = processGroupData(group, null, getUserAccessLevel(user_type, 'technician'));
        return ret;
    }).filter((row) => { return typeof row.parent_id == 'undefined' });
    var group_data = group.data ? processGroupData(group.data, [selected_device], getUserAccessLevel(user_type, 'technician')) : null;
    var device_data = processDeviceData(selected_device, group_data.type);

    return <ClearwaysDeviceSettingsForm selected_device={device_data} sites={sites.data} selected_group={group_data} selected_subgroup={group_data ? group_data.subgroups.filter((subgroup) => { return subgroup.uuids.indexOf(uuid) > -1 })[0] : {}} groups={basic_groups_data} />
}

ClearwaysDeviceSettings.propTypes = {
    uuid: PropTypes.string,
    selected_device: PropTypes.object,
    user_type: PropTypes.string,
    deviceLayout: PropTypes.string,
};

export default ClearwaysDeviceSettings;